import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .listHead {
    background: ${colors.grayExtraLight};
    box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.1);
    padding: 5px 15px 5px 13px;
    position: relative;
  }

  .listHead.testab-active {
    background: #fff;
  }

  .listHead h1,
  .listHead .title {
    color: ${colors.grayDeep};
    font-size: 1.0625em; /* 17/16 */
    font-weight: normal;
    line-height: 1.3;
    margin-bottom: 5px;
  }

  .listHead .title h1 {
    display: inline;
  }

  .listHead p {
    font-size: 0.93em; /* 14/16 */
    margin: 0;
  }

  .empty {
    background: ${colors.grayLight};
    text-indent: -9999px;
    width: 100px;
    display: inline-block;
    height: 0.75em;
    border-radius: 8px;
    position: relative;
    top: 4px;
  }

  .filter {
    float: right;
    font-weight: bold;
    text-decoration: none;
  }

  :global(.rtl) .filter {
    float: left;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/ListHead/listHeadStyles.js